export default __webpack_public_path__ + "static/media/urlImg.4b5e64ce.svg";